import { render, staticRenderFns } from "./DogRegistrationIndividualList.vue?vue&type=template&id=f8e0e46c"
import script from "./DogRegistrationIndividualList.vue?vue&type=script&lang=ts"
export * from "./DogRegistrationIndividualList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports